import { dataCube } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCube = /*#__PURE__*/createIcon(dataCube)
export default IconCube
